import { gql } from '@apollo/client';

export const getMaxTimeStamps = gql`
    query getMaxTimeStamps($frequency: SamyaString!, $featureName: String) {
        getMaxTimeStamps(frequency: $frequency, featureName: $featureName) {
            tableName
            startTimestamp
            endTimestamp
        }
    }
`;

export const getCampaignCalender = gql`
    query getCalendar($yearLabel: [Int]!, $frequency: SamyaString!) {
        getCustomCalendar(yearLabel: $yearLabel, frequency: $frequency) {
            periodNo
            yearLabel
            periodStartDate
            periodEndDate
            frequency
            periodLabel
            dayLabel
            weekLabel
            monthLabel
            quarterLabel
        }
    }
`;
